import { useEffect, useRef, useState } from 'react';
import { apiUploadIdCardFront } from '@/api';
import { LoadingMask, showToast } from '@/utils/utils';
interface Props {
  onCancel?: (e: any) => void;
}
const fileLength = 1;
export default function Certification({ onCancel }: Props) {
  // 取url中iccid的参数
  const urlParams = new URLSearchParams(window.location.search);
  const iccid = urlParams.get('iccid') || '';
  const [files, setFiles] = useState<File[]>([]);
  const [fileImgs, setFileImgs] = useState<{ src: string; key: string }[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  async function onOk() {
    if (fileImgs?.length <= 0) {
      return showToast('请上传身份证正面');
    }
    LoadingMask.show('正在验证...');
    const res = await apiUploadIdCardFront(files[0], iccid, 'back');
    if (res.data?.data?.code === 0) {
      onCancel && onCancel(true);
      showToast('校验通过，请进行下一步真人认证');
    } else if (res.data?.data?.code === 60002) {
      showToast(res.data?.data?.msg);
      onCancel && onCancel(false);
    } else {
      showToast(res.data?.data?.msg);
    }
    LoadingMask.hide();
  }
  useEffect(() => {
    if (fileImgs?.length > 0 && files.length > 0) {
      onOk();
    }
  }, [files, fileImgs]); // eslint-disable-line
  const handleImageUpload = (event: any) => {
    let filesList = event.target.files;
    let _files: File[] = [...files];
    if (filesList && filesList[0]) {
      _files.push(filesList[0]);
    }
    if (_files.length > fileLength) {
      _files = _files.slice(0, fileLength);
    }

    setFiles(_files);
    for (let i = 0; i < filesList.length; i++) {
      const file = filesList[i];
      // 创建FileReader实例
      const reader = new FileReader();

      reader.onload = (e: any) => {
        // 使用文件名或索引来保证顺序
        setFileImgs((prevImages) => [...prevImages, { src: e.target.result, key: file.name || i }]);
      };

      reader.readAsDataURL(file);
    }
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  function handleRemoveImg(idx: number) {
    let t = [...files];
    t.splice(idx, 1);
    setFiles(t);
    let tt = [...fileImgs];
    tt.splice(idx, 1);
    setFileImgs(tt);
  }
  return (
    <div className="bg-primary-light facingPhoto">
      <div className="facingPhoto-bg d-flex-r ai-center jc-between pl-20 pr-20">
        <img className="bw-100" src="/pic/certification/photo_bg_back.png" alt="" />
      </div>
      <div className="text-center mt-20">
        <div className="font-size-18 mb-5">上传并提交您的证件照片</div>
        <div className="font-size-14" style={{ color: '#9E9E9E' }}>
          为了配合国家监管要求，请上传身份证正反面照片
        </div>
      </div>
      <div className="p-20 d-flex-r ai-center jc-between bw-100">
        <div style={{ margin: 'auto' }} className="facingPhoto-box-img pt-16">
          <div
            className={`w-220 h-150 pos-r  overflow-hidden ${files.length >= fileLength ? 'd-none' : ''}`}
            style={{ margin: 'auto' }}
          >
            <img className="w-220 h-150 d-flex-r jc-center" src="/pic/certification/reverseSidePhoto.png" alt="" />
            <input
              className="view-opacity-0 pos-a l-0 t-0 bw-100 bh-100 line-height-60"
              type="file"
              ref={inputRef}
              accept="image/*"
              onChange={handleImageUpload}
            />
          </div>

          {fileImgs.map((item, idx) => {
            return (
              <div key={item.key} className="w-220 h-150 border pos-r mr-10" style={{ margin: 'auto' }}>
                <img className="w-220 h-150" src={item.src} alt="" />
                <img
                  className="pos-a w-16 h-16 t-0 r-0"
                  onClick={() => handleRemoveImg(idx)}
                  src="/pic/icon_upload_close.png"
                  alt=""
                />
              </div>
            );
          })}
          <div className="text-center mt-15 font-size-16">
            上传<span style={{ color: '#3278FC' }}>国徽面</span>{' '}
          </div>
        </div>
      </div>
      {/* <Button type="primary" size="md" shape="circle" className='mt-10 ml-20 mr-20 button-primary' long onClick={() => onOk()}>
                      保存
                  </Button> */}
      <div className="pl-20 pr-20 pb-20">
        <div className="font-size-16 text-color-6 mt-10 mb-10">拍摄须知</div>
        <div className="d-flex-r ai-center jc-between">
          <div style={{ width: 'calc(25% - 8px)' }}>
            <img className="bw-100" src="/pic/certification/photo6.png" alt="" />
            <div className="d-flex-r ai-center jc-start mt-5">
              <img className="w-14" src="/pic/certification/success.png" alt="" />
              <div className="ml-3 font-size-12" style={{ color: '#9E9E9E' }}>
                标准拍照
              </div>
            </div>
          </div>
          <div style={{ width: 'calc(25% - 8px)' }}>
            <img className="bw-100" src="/pic/certification/photo8.png" alt="" />
            <div className="d-flex-r ai-center jc-start mt-5">
              <img className="w-14" src="/pic/certification/error.png" alt="" />
              <div className="ml-3 font-size-12" style={{ color: '#9E9E9E' }}>
                边框缺失
              </div>
            </div>
          </div>
          <div style={{ width: 'calc(25% - 8px)' }}>
            <img className="bw-100" src="/pic/certification/photo7.png" alt="" />
            <div className="d-flex-r ai-center jc-start mt-5">
              <img className="w-14" src="/pic/certification/error.png" alt="" />
              <div className="ml-3 font-size-12" style={{ color: '#9E9E9E' }}>
                照片模糊
              </div>
            </div>
          </div>
          <div style={{ width: 'calc(25% - 8px)' }}>
            <img className="bw-100" src="/pic/certification/photo9.png" alt="" />
            <div className="d-flex-r ai-center jc-start mt-5">
              <img className="w-14" src="/pic/certification/error.png" alt="" />
              <div className="ml-3 font-size-12" style={{ color: '#9E9E9E' }}>
                闪光强烈
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
